export const toAmountString = (number, showAsDebit) => {
  if (!number && number !== 0) return ''
  const parsedNumber = typeof number === 'number' ? number : parseFloat(number, 10)
  if (Number.isNaN(parsedNumber)) return ''
  const valueToFormat = parsedNumber === 0 ? 0 : parsedNumber
  const formattedNumber = valueToFormat.toLocaleString('en-CA', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    currency: 'CAD',
    currencyDisplay: 'symbol',
    style: 'currency',
  })
  return showAsDebit ? `${formattedNumber.replace('-', '')}` : formattedNumber
}

export const fromAmountString = (string) => {
  if (!string) return null
  if (typeof string === 'number') return string
  return parseFloat(string.replace(/[^0-9.-]+/g, ''), 10)
}

export const roundToDecimalPlaces = (number, decimalPlaces = 2) =>
  // toFixed returns a string, so we need to parse it to a float again
  parseFloat(number.toFixed(decimalPlaces))

export const fromAmountField = (stringAmount, decimalPlaces = 2) => {
  // Certain decimal places cause long tail decimals, which we need to round off
  const parsedAmount = parseFloat(stringAmount.replaceAll(',', ''))
  return roundToDecimalPlaces(parsedAmount, decimalPlaces)
}
